import { MatSnackBar } from '@angular/material/snack-bar';
import { ICellRendererParams } from '@ag-grid-community/core';
import { Component, OnDestroy } from "@angular/core";
import { PlanyardService } from "src/app/modules/planyard/planyard.service";
import { SnackbarComponent } from 'src/app/components/snackbar/snackbar.component';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: "app-order-status-cell-renderer",
  templateUrl: "./order-status-cell-renderer.component.html",
  styleUrls: ["./order-status-cell-renderer.component.scss"],
})
export class OrderStatusCellRendererComponent  implements OnDestroy {
  params: ICellRendererParams;
  cssClass = {};
  initialStatus;
  statusList:any [] = [];
  private destroy$ = new Subject<void>();

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.params.data.Status = this.params.data.status || this.params.data.Status;
    this.initialStatus = this.params.data.Status;
     this.statusList= ['Pending', 'Shipped', 'Cancelled','Unshipped', 'Acknowledged','Delivered','Created',"Removal" ,
     'CLOSED','CANCELLED','DELETED', 'DRAFT','WORKING','Canceled','RECEIVING','Shipping','IN_TRANSIT','PENDING_SHIPMENT_DETAILS' ]
  }

  constructor(
    private planyardService: PlanyardService,
    private snackBar: MatSnackBar
  ) { }
  

  statusChanged(event: any) {
    this.params.api.forEachNode(node => {
      if (node.data.Orderid === this.params.data.Orderid) {
        node.setDataValue("Status", event);
      }
    });
    this.planyardService.UpdateOrderStatus(this.params.data.Orderid, event).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res) => {
        this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 3000,
            horizontalPosition: 'center',
            data: {
              title: 'Status updated successfully',
              action: 'Dismiss',
              type: 'success',
            },
          }
      );
      },
     error: (err) => {
      this.snackBar.openFromComponent(SnackbarComponent,
        {
          duration: 3000,
          horizontalPosition: 'center',
          data: {
            title: 'Status update failed',
            action: 'Dismiss',
            type: 'error',
          },
        }
    );
      this.params.api.forEachNode(node => {
        if (node.data.Orderid === this.params.data.Orderid) {
          node.setDataValue("Status", this.initialStatus);
        }
      });
     }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
